<template>
  <div class="header-part clearfix">
    <!--显示内容-->
    <div class="header-left-box float-left">
      <div class="header-logo">超田伴成长运营管理中心</div>
    </div>
    <div class="header-right-box float-right">
      <div class="header-user-info clearfix">
        <div class="header-user-avatar float-left">
          <img style="object-fit: cover" :src="avatar" alt="image" />
        </div>
        <div class="header-user-username float-left">
          <el-dropdown @command="handlerCommand">
                      <span class="el-dropdown-link">
                        {{ userName }} <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="userInfo">用户信息</el-dropdown-item>
              <el-dropdown-item command="updatePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="updatePwdDialog">
          <el-dialog
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              title="修改密码"
              center
              :visible.sync="updatePwdDialogVisit"
              width="500px">
            <div class="editor-content">
              <el-form size="medium" label-width="100px">
                <el-form-item label="账号名">
                  <el-input v-model="newUsername" placeholder="请输入旧密码账号名."></el-input>
                </el-form-item>
                <el-form-item label="旧密码" required>
                  <el-input v-model="oldPassword" placeholder="请输入旧密码."></el-input>
                </el-form-item>
                <el-form-item label="新密码" required>
                  <el-input v-model="newPassword" placeholder="请输入新密码."></el-input>
                </el-form-item>
                <el-form-item label="重复新密码" required>
                  <el-input v-model="renewPassword" placeholder="请再次输入新密码."></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="dialog-action" slot="footer" style="text-align: center">
              <el-button size="medium" @click="onEditorCancel">取 消</el-button>
              <el-button type="primary" size="medium" @click="onEditorConfirm">提 交</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as api from '../api/api'

import { hex_md5 } from "@/utils/md5";

export default {
  data() {
    return {
      newUsername: this.userName,
      oldPassword: '',
      newPassword: '',
      renewPassword: '',
      updatePwdDialogVisit: false,
    }
  },
  computed: {
    userName() {
      return this.$store.state.userName
    },
    avatar() {
      return this.$store.state.avatar;
    }
  },
  methods: {
    handlerCommand(command) {
      if (command === 'userInfo') {
        //TODO:
      } else if (command === 'updatePassword') {
        //TODO:
        this.updatePwdDialogVisit = true;
        this.newUsername = this.userName;
      } else if (command === 'logout') {
        api.logout().then(result => {
          if (result.code === api.SUCCESS_CODE) {
            this.$store.dispatch('logout');
            this.$router.push('/login');
          }
        }).catch(() => {
          this.$store.dispatch('logout');
          this.$router.push('/login');
        });
      }
    },
    onEditorCancel(){
      this.oldPassword = ''
      this.newPassword = ''
      this.renewPassword = ''
      this.updatePwdDialogVisit = false;
    },
    onEditorConfirm() {
      if (this.oldPassword === '') {
        return this.$message({
          message: '请输入旧密码',
          type: 'error'
        });
      }

      if (this.newPassword === '') {
        return this.$message({
          message: '请输入新密码',
          type: 'error'
        });
      }

      if (this.renewPassword === '') {
        return this.$message({
          message: '请输入重复新密码',
          type: 'error'
        });
      }

      if (this.newPassword !== this.renewPassword) {
        this.$message({
          message: '两次输入的密码不一致',
          type: 'error'
        });
      }

      let md5OldPwd = hex_md5(this.oldPassword)
      let md5NewPwd = hex_md5(this.newPassword)

      api.updateAdminPassword(this.newUsername, md5OldPwd, md5NewPwd).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          this.$message({
            message: '修改密码成功',
            type: 'success'
          });

          // 退出登录
          api.logout().then(result => {
            if (result.code === api.SUCCESS_CODE) {
              this.$store.dispatch('logout');
              this.$router.push('/login');
            }
          }).catch(() => {
            this.$store.dispatch('logout');
            this.$router.push('/login');
          });

          // 清空数据
          this.oldPassword = ''
          this.newPassword = ''
          this.renewPassword = ''
          this.updatePwdDialogVisit = false;
        }else {
          this.$message({
            message: result.msg,
            type: 'error'
          });
        }
      });
    }
  },
  mounted() {

  }
}
</script>
<style>

.header-user-info {
  margin-right: 30px;
}

.header-user-username .el-dropdown-link {
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  margin-left: 10px;
}

.header-user-avatar img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  vertical-align: middle;
}

.header-logo {
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
</style>
